import { Theme } from '@mui/material';

export const sxStyles = {
  title: (theme: Theme) => ({
    marginTop: '2.75rem',
    marginBottom: '2.5rem',
    color: theme.palette.primary.main,
  }),
};
